import * as React from 'react';

interface IConfirmContext {
  start: (action: () => void, title: string, text: string) => void;
}

const ConfirmContext = React.createContext<IConfirmContext | null>(null);

const useConfirm = (): IConfirmContext => {
  const ctx = React.useContext(ConfirmContext);
  if (!ctx) throw new Error('useConfirm must be used inside a <Confirm> provider.');
  return ctx;
}

export { IConfirmContext, ConfirmContext, useConfirm }
